
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-equipment-storage",
      function () {
        return require("private-next-pages/office-equipment-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-equipment-storage"])
      });
    }
  